 // eslint-disable-next-line
// export default('ws://69.62.83.82:8888/webc')
 // eslint-disable-next-line
export default('wss://api-pay.pitech.ae/webc')
// eslint-disable-next-line
// export default('ws://localhost:8888/webc')
// export default('wss://82.180.161.245:8888')
